import React from 'react';
import ResultList from '../../components/ResultList/ResultList';

import './MetaDataSearchPage.scss';

type ViewType = 'map' | 'card' | 'table' | 'grid' | 'summary';

// Interface for card display field configuration
interface CardDisplayField {
  field: string;
  label: string;
}

interface MetaDataSearchPageProps {
  viewType?: ViewType;
  detailsPagePath?: string;
  cardDisplayFields?: CardDisplayField[];
  cardBadgeField?: string;
  cardColumns?: number;
  agolEligibleFormats?: string[];
}

const MetaDataSearchPage: React.FC<MetaDataSearchPageProps> = ({
  viewType = 'card',
  detailsPagePath = '/voyager-details',
  cardDisplayFields = [],
  cardBadgeField = '',
  cardColumns = 4,
  agolEligibleFormats = [],
}) => {
  return (
    <main className="search-results-page">
      <div className="search-results">
        <div className="container-fluid">
          <div className="row main-body">
            <div className="col-12">
              <ResultList
                stateKey="search"
                viewType={viewType}
                detailsPagePath={detailsPagePath}
                cardDisplayFields={cardDisplayFields}
                cardBadgeField={cardBadgeField}
                cardColumns={cardColumns}
                agolEligibleFormats={agolEligibleFormats}
              />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default MetaDataSearchPage;
